import { Controller } from "stimulus"
import { listenForReservation } from "../channels/reservation_channel"

export default class extends Controller {

  connect() {
		listenForReservation(this.data.get('id'))
	}
	
}